import createClient from '@magalucloud/sdk-idmagalu-js';
import Vue from 'vue';

let clientIDMagalu = {};

const sessionListeners = [];

const setHeaders = (request) => {
  request.headers.set('Authorization', `Bearer ${clientIDMagalu.getToken()}`);
  request.headers.set('Accept', 'application/json');
  request.headers.set('Content-type', 'application/json');
};

const notifySessionExpired = () => {
  if (sessionListeners.length === 0) {
    localStorage.removeItem('id_magalu_id_token');
    localStorage.removeItem('id_magalu_refresh_token');
    localStorage.removeItem('id_magalu_access_token');
    localStorage.removeItem('id_magalu_expires_in');
    clientIDMagalu.logout();
    window.location.reload();
  } else {
    sessionListeners.forEach((listener) => listener.onSessionExpired());
  }
};

const onResponse = (response) => {
  if (response.status === 401) {
    console.log('Sessão expirada mediante resposta 401.');
    notifySessionExpired();
  }
  return response;
};

const setSessionData = (key, data) => {
  sessionStorage.setItem(key, data);
};

const ID_TOKEN_KEY = 'id_magalu_id_token';
const ACCESS_TOKEN_KEY = 'id_magalu_access_token';

export const authIDMagalu = {
  init() {
    return new Promise((resolve, reject) => {
      const clientId = process.env.VUE_APP_ID_MAGALU_CLIENT_ID || 'WwlEwdthnkwsX9XfrPbApVX8TbhwDfE8dUeSS9eMc0U';

      createClient({
        client_id: clientId,
        redirect_uri: `${window.location.origin}`,
        scope: 'openid',
        useRefreshTokens: true,
      })
        .then((resClient) => {
          clientIDMagalu = resClient;
          resolve(clientIDMagalu.isAuthenticated());
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getClientIDMagalu() {
    return clientIDMagalu;
  },
  registerSessionListener(listener) {
    if (listener.onSessionExpired) sessionListeners.push(listener);
  },
  login() {
    clientIDMagalu.login();
  },
  doLogout() {
    clientIDMagalu.logout();
    window.location.reload();
  },
  isAuthenticated() {
    return clientIDMagalu.isAuthenticated();
  },
  setTokenInSession() {
    setSessionData(ACCESS_TOKEN_KEY, clientIDMagalu.getToken());
    setSessionData(ID_TOKEN_KEY, clientIDMagalu.store.getItem(ID_TOKEN_KEY));
  },
  createInterceptors() {
    Vue.http.interceptors.push((request, next) => {
      if (clientIDMagalu.isAuthenticated()) {
        setHeaders(request);
      } else {
        console.log('Sessão expirada mediante expiração do token.');
        notifySessionExpired();
      }
      next((response) => onResponse(response));
    });
  },
  removerDadosIdMagalu() {
    localStorage.removeItem('id_magalu_id_token');
    localStorage.removeItem('id_magalu_refresh_token');
    localStorage.removeItem('id_magalu_access_token');
    localStorage.removeItem('id_magalu_expires_in');
    localStorage.removeItem('xTenantId');
  },
};

const plugin = () => {
  Vue.prototype.$authIDMagalu = clientIDMagalu;
};

if (typeof window !== 'undefined' && window.Vue) { // eslint-disable-line no-undef
  window.Vue.use(plugin); // eslint-disable-line no-undef
}

export default plugin;
